// removed by extract-text-webpack-plugin
module.exports = {"albumInfo":"Cd52IejDhDu5AVo19FC51","infoTable":"_30nPKRGYKb8hRFAzTjUEyr","infoCell":"_3sOXC8IXA3qyyH-5EWW-qW","watermarkContainer":"_1guJoid6ewrNn3_JUvwWRF","albumName":"_28nW7PGo3eHrHyLsN6NfFX","artist":"rfmKB3EJPtakbe_qm98mz","smallHeader":"_2RmUzWechAiotZQag1bS2O","sentBy":"N4KumltMEtW1W9rtHTT8Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/PlaylistAlbumInfo/PlaylistAlbumInfo.scss
// module id = 1291
// module chunks = 1